var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 30,
    viewBox: "0 0 102 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 26.25L7.25695 29.1178C8.3766 29.6309 9.7028 29.2837 10.4272 28.2876V28.2876C11.2519 27.1536 12.8298 26.883 13.9852 27.6773L14.4782 28.0163C16.0283 29.0819 18.1587 28.5879 19.0816 26.9488L24.1226 17.9959C25.0016 16.4347 26.654 15.4688 28.4456 15.4688V15.4688C29.7879 15.4688 31.0728 14.9249 32.0073 13.9613L33.3304 12.5967C34.7463 11.1366 36.6934 10.3125 38.7273 10.3125H40.8804C41.538 10.3125 42.1675 10.0461 42.6252 9.57401L42.75 9.44535C43.735 8.42951 45.3979 8.54712 46.2302 9.69149V9.69149C46.8846 10.5913 48.0929 10.8873 49.0891 10.3918L54.6744 7.61359C56.2331 6.8383 58.123 7.28477 59.17 8.67562L60.2018 10.0464C61.7967 12.1652 65.1614 11.2451 65.4563 8.60961L65.6675 6.72196C65.818 5.37647 67.3486 4.67719 68.4643 5.44421V5.44421C69.3362 6.04362 70.5348 5.76137 71.0476 4.83591L71.8369 3.4115C72.823 1.63199 75.1769 1.1746 76.7576 2.45538L78.8004 4.11061C79.6418 4.79237 80.2622 5.70829 80.5832 6.74257L82.3239 12.3526C82.9229 14.2829 85.4331 14.764 86.7034 13.192V13.192C87.5732 12.1157 89.1468 11.939 90.2336 12.7956L101 21.282V30H1V26.25Z",
    fill: "url(#paint0_linear_1295_979)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 26.25L7.25695 29.1178C8.3766 29.6309 9.7028 29.2837 10.4272 28.2876V28.2876C11.2519 27.1536 12.8298 26.883 13.9852 27.6773L14.4782 28.0163C16.0283 29.0819 18.1587 28.5879 19.0816 26.9488L24.1226 17.9959C25.0016 16.4347 26.654 15.4688 28.4456 15.4688V15.4688C29.7879 15.4688 31.0728 14.9249 32.0073 13.9613L33.3304 12.5967C34.7463 11.1366 36.6934 10.3125 38.7273 10.3125H40.8804C41.538 10.3125 42.1675 10.0461 42.6252 9.57401L42.75 9.44535C43.735 8.42951 45.3979 8.54712 46.2302 9.69149V9.69149C46.8846 10.5913 48.0929 10.8873 49.0891 10.3918L54.6744 7.61359C56.2331 6.8383 58.123 7.28477 59.17 8.67562L60.2018 10.0464C61.7967 12.1652 65.1614 11.2451 65.4563 8.60961L65.6675 6.72196C65.818 5.37647 67.3486 4.67719 68.4643 5.44421V5.44421C69.3362 6.04362 70.5348 5.76137 71.0476 4.83591L71.8369 3.4115C72.823 1.63199 75.1769 1.1746 76.7576 2.45538L78.8004 4.11061C79.6418 4.79237 80.2622 5.70829 80.5832 6.74257L82.3239 12.3526C82.9229 14.2829 85.4331 14.764 86.7034 13.192V13.192C87.5732 12.1157 89.1468 11.939 90.2336 12.7956L101 21.282",
    stroke: "#CD3D42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1295_979",
    x1: 1.21281,
    y1: 0,
    x2: 1.21281,
    y2: 29.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD3D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3D42",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD1);
export default __webpack_public_path__ + "static/media/D1.d694aa742a7bb8e7273bc128e655985d.svg";
export { ForwardRef as ReactComponent };